/* eslint-disable no-useless-catch */
import Service from "../../service";

const MemberService = {
  getFilter: async (token) => {
    try {
      return await Service.get(`/accounts/filter`, token);
    } catch (error) {
      throw error;
    }
  },
  getContacts: async (token, search) => {
    try {
      return await Service.get(
        `/accounts/contact?${search ? `search=${search}` : ""}`,
        token
      );
    } catch (error) {
      throw error;
    }
  },
  getContactsList: async (token, search) => {
    try {
      return await Service.get(
        `/accounts/contact/list?${search ? `search=${search}` : ""}`,
        token
      );
    } catch (error) {
      throw error;
    }
  },
  getPeopleList: async (token, search) => {
    try {
      return await Service.get(
        `/accounts/contact?page=${1}&size=${20}&${
          search ? `search=${search}` : ""
        }`,
        token
      );
    } catch (error) {
      throw error;
    }
  },
  removeContact: async (data, token) => {
    try {
      return await Service.remove({ url: "/accounts/contact", data, token });
    } catch (error) {
      throw error;
    }
  },
  searchEverything: async (data, token) => {
    try {
      return await Service.post({
        url: "/accounts/account/search",
        data,
        token,
      });
    } catch (error) {
      throw error;
    }
  },
  getAccountWithFilter: async (data, token, page, perPage = 20) => {
    try {
      return await Service.post({
        url: `/accounts/account/list?current_page=${page}&items_per_page=${perPage}`,
        data,
        token,
      });
    } catch (error) {
      throw error;
    }
  },
  getPeopleWithFilter: async (data, token, page, perPage) => {
    try {
      return await Service.post({
        url: `/accounts/contact/list?current_page=${page}&items_per_page=${perPage}`,
        data,
        token,
      });
    } catch (error) {
      throw error;
    }
  },

  archiveAccount: async (data, token) => {
    try {
      return await Service.update({
        url: `/accounts/account/archive`,
        data,
        token,
      });
    } catch (error) {
      throw error;
    }
  },
  getCommunicationMmber: async (data, token, page, perPage) => {
    try {
      return await Service.post({
        url: `/accounts/account/communication?current_page=${page}&items_per_page=${perPage}`,
        data,
        token,
      });
    } catch (error) {
      throw error;
    }
  },

  // Get export accounts
  getExportAccounts: async ({ data, token }) => {
    try {
      return await Service.post({
        url: `/accounts/account/export`,
        data,
        token,
      });
    } catch (error) {
      throw error;
    }
  },
  // Get export contacts
  getExportContacts: async ({ data, token }) => {
    try {
      return await Service.post({
        url: `/accounts/contact/export`,
        data,
        token,
      });
    } catch (error) {
      throw error;
    }
  },

  // Get Contacts list for  related
  getContactsListForRelated: async ({
    token,
    data,
    page = 1,
    perPage = 10,
  }) => {
    try {
      return await Service.post({
        url: `/accounts/contact/list/related?current_page=${page}&items_per_page=${perPage}`,
        data,
        token,
      });
    } catch (error) {
      throw error;
    }
  },

  getMembersFeeds: async ({ token, page, limit, accountId }) => {
    try {
      return await Service.get(
        `/pastoral/feed/?current_page=${page}&items_per_page=${limit}&accountId=${accountId}`,
        token
      );
    } catch (error) {
      throw error;
    }
  },

  // Event Api's
  getEventListByID: async ({ token, data, current_page, items_per_page }) => {
    try {
      return await Service.post({
        url: `/pastoral/events/account?current_page=${current_page}&items_per_page=${items_per_page}`,
        data,
        token,
      });
    } catch (error) {
      throw error;
    }
  },

  // Event Api's
  getContactListByID: async ({ token, accountId }) => {
    try {
      return await Service.get(
        `/pastoral/contacts/?current_page=1&items_per_page=5000&accountId=${accountId}`,
        token
      );
    } catch (error) {
      throw error;
    }
  },

  // Event Api's
  getEventByContact: async ({ token, contactId }) => {
    try {
      return await Service.get(
        `/pastoral/events/event/contact?contactId=${contactId}`,
        token
      );
    } catch (error) {
      throw error;
    }
  },
};

export default MemberService;
